<div class="bm-card bm-card-sm bm-card-border border-base-300">
  <div class="bm-card-body">
    @if (heading) {
      <div class="bm-card-title text-sm">{{ heading }}</div>
    }

    <!-- Typ-Auswahl. Bei Staging-Configs nur PickPoint/Technikerversand. -->
    <div class="flex gap-1 mb-3 flex-wrap">
      @for (t of visibleShippingTypes(); track t.value) {
        <!-- Tooltip-Wrapper: zeigt den Sperr-Grund auch bei DEAKTIVIERTEM Button
             an (disabled-Buttons erhalten selbst kein :hover). -->
        <span class="inline-flex"
              [class.bm-tooltip]="isTypeDisabled(t.value)"
              [attr.data-tip]="typeDisabledReason(t.value)">
          <button class="bm-btn bm-btn-xs" type="button"
            [class.bm-btn-primary]="selectedType() === t.value"
            [disabled]="isTypeDisabled(t.value)"
            [title]="t.label"
            (click)="setShippingType(t.value)">
            <fa-icon [icon]="t.icon" class="mr-1" />{{ t.label }}
          </button>
        </span>
      }
    </div>

    <!-- PickPoint Auswahl -->
    @if (selectedType() === 'pickpoint') {
      <fieldset class="bm-fieldset">
        <label class="bm-fieldset-label">PickPoint-Station</label>
        <div class="flex flex-row gap-2 items-center">
          <div class="flex-1 flex items-center gap-2 min-h-[2.25rem]">
            @if (selectedStation(); as sel) {
              <span class="bm-badge bm-badge-neutral">PP-{{ sel.pp_id }}</span>
              <span>{{ sel.name }}</span>
              @if (sel.address_zip || sel.address_city) {
                <span class="opacity-60 text-sm">{{ sel.address_zip }} {{ sel.address_city }}</span>
              }
            } @else {
              <span class="opacity-60 italic">Nicht ausgewählt</span>
            }
          </div>
          <button class="bm-btn bm-btn-ghost" type="button"
                  [disabled]="!canOpenMap()"
                  [title]="canOpenMap() ? 'Auf Karte auswählen' : 'Kein Auftragsort mit Koordinaten verfügbar'"
                  (click)="showMapPicker.set(true)">
            <fa-icon [icon]="iconMap" class="mr-1" />
            Auf Karte wählen
          </button>
        </div>
      </fieldset>

      <!-- PM-Code: Pflichtfeld bei PickPoint. Liegt grundsaetzlich im
           erweiterten Bereich (siehe unten) — wird beim Anlegen aus dem
           System-User (ID 1) vorbelegt; bei manuellen Korrekturen klickt
           der User die Sektion auf. -->
    }

    <!-- Filialversand -->
    @if (selectedType() === 'store_shipping') {
      <fieldset class="bm-fieldset">
        <label class="bm-fieldset-label">Ziel-Filiale (aus Ticket)</label>
        <div class="min-h-[2.25rem] flex items-center gap-2">
          @if (context?.ticket_store_nr) {
            <span>{{ context?.ticket_store_nr }}</span>
            @if (context?.ticket_store_name) {
              <span class="opacity-60">{{ context?.ticket_store_name }}</span>
            }
          } @else if (ticketStoreId) {
            <span class="opacity-60 italic">Filiale wird geladen…</span>
          } @else {
            <span class="opacity-60 italic">Keine Filiale am Ticket</span>
          }
        </div>
      </fieldset>
    }

    <!-- Kundenversand: Ziel-Kunde waehlen (Pflicht bei internen Projekten) -->
    @if (selectedType() === 'customer_shipping') {
      <fieldset class="bm-fieldset">
        <label class="bm-fieldset-label">Ziel-Kunde (Rücksendung)</label>
        @if (!context) {
          <div class="text-sm opacity-60 italic">Wird geladen…</div>
        } @else if (targetCustomerId()) {
          <!-- Gewaehlter Ziel-Kunde + Rueckadresse-Status -->
          <div class="bm-alert bm-alert-soft flex items-center"
               [class.bm-alert-success]="selectedCustomerHasReturn()"
               [class.bm-alert-error]="!selectedCustomerHasReturn()">
            <fa-icon [icon]="selectedCustomerHasReturn() ? iconCheck : iconTimes" class="mr-2" />
            <div>
              <strong>{{ selectedCustomerName() }}</strong>
              @if (selectedCustomerHasReturn()) { — Rücksendeadresse hinterlegt }
              @else {
                — keine Rücksendeadresse hinterlegt
                <a [routerLink]="['/kunde', targetCustomerId()]" target="_blank"
                   class="g-link underline ml-1">Rücksendeadresse beim Kunden hinterlegen ↗</a>
              }
            </div>
            <button type="button" class="bm-btn bm-btn-ghost bm-btn-xs ml-auto" (click)="clearTargetCustomer()">Ändern</button>
          </div>
        } @else {
          <!-- Kunden-Suche -->
          <div class="relative">
            <input type="text" class="bm-input w-full" placeholder="Kunde suchen…"
                   [(ngModel)]="customerSearch" (ngModelChange)="onCustomerSearch($event)" />
            @if (showCustomerDropdown() && customerResults().length > 0) {
              <div class="absolute z-20 mt-1 w-full bg-base-100 border border-base-200 rounded-lg shadow-lg max-h-60 overflow-auto">
                @for (cust of customerResults(); track cust.id) {
                  <button type="button" class="block w-full text-left px-3 py-2 hover:bg-base-200 text-sm"
                          (click)="selectCustomer(cust)">
                    {{ cust.name }}
                    @if (!cust.has_return_address) { <span class="text-error text-xs">(keine Rücksendeadresse)</span> }
                  </button>
                }
              </div>
            }
          </div>
          <!-- Hinweis je nach Projektart -->
          @if (context.project_is_internal) {
            <span class="text-warning text-xs mt-1">Internes Projekt: bitte einen Ziel-Kunden mit Rücksendeadresse wählen.</span>
          } @else if (context.customer_has_return_address) {
            <span class="text-xs opacity-60 mt-1">
              Ohne Auswahl: Rücksendung an den Projekt-Kunden@if (context.customer_name) { <strong>{{ context.customer_name }}</strong> }.
            </span>
          } @else {
            <div class="bm-alert bm-alert-error bm-alert-soft mt-1">
              <fa-icon [icon]="iconTimes" class="mr-2" />
              <div>
                Projekt-Kunde hat keine Rücksendeadresse – bitte einen Ziel-Kunden wählen@if (context.customer_id) {
                  oder <a [routerLink]="['/kunde', context.customer_id]" target="_blank" class="g-link underline">die Rücksendeadresse hinterlegen ↗</a>
                }.
              </div>
            </div>
          }
        }
      </fieldset>
    }

    <!-- Versandart + Paket-Geschwindigkeit (eine Zeile, beide inhaltsbreit) -->
    <div class="flex gap-x-6 mt-2 flex-wrap">
      <fieldset class="bm-fieldset">
        <label class="bm-fieldset-label">Versandart</label>
        <div class="flex gap-1 flex-wrap">
          @for (m of visibleShipmentMethods(); track m.value) {
            <button class="bm-btn bm-btn-xs" type="button"
              [class.bm-btn-primary]="shipmentMethod() === m.value"
              (click)="setShipmentMethod(m.value)">
              <fa-icon [icon]="m.icon" class="mr-1" />{{ m.label }}
            </button>
          }
        </div>
      </fieldset>

      @if (shipmentMethod() === 'parcel') {
        <fieldset class="bm-fieldset">
          <label class="bm-fieldset-label">Paket-Geschwindigkeit</label>
          <div class="flex gap-1 flex-wrap">
            @for (s of packageSpeeds; track s.value) {
              <button class="bm-btn bm-btn-xs" type="button"
                [class.bm-btn-primary]="packageSpeed() === s.value"
                (click)="packageSpeed.set(s.value)">
                <fa-icon [icon]="s.icon" class="mr-1" />{{ s.label }}
              </button>
            }
          </div>
        </fieldset>
      }
    </div>

    @if (selectedType() === 'store_shipping') {
      <!-- Artikel-Disposition (nur bei Filialversand waehlbar) -->
      <fieldset class="bm-fieldset">
        <label class="bm-fieldset-label">Artikel bei Versand</label>
        <div class="flex gap-1 flex-wrap">
          <button class="bm-btn bm-btn-xs" type="button"
                  [class.bm-btn-primary]="articleDisposition() === 'technician_transfer'"
                  (click)="articleDisposition.set('technician_transfer')">
            Auf Techniker umbuchen
          </button>
          <button class="bm-btn bm-btn-xs" type="button"
                  [class.bm-btn-primary]="articleDisposition() === 'consumed'"
                  (click)="articleDisposition.set('consumed')">
            Verbraucht (installiert)
          </button>
        </div>
      </fieldset>
    }

    <!-- Ziel-Techniker + Ziel-Lager des Technikers — immer sichtbar (nicht mehr
         im Ausklappbereich), da zentrale Angaben fuer den Technikerversand. -->
    @if (showTechnicianSelector()) {
      <!-- Ziel-Techniker: Regel "vom Auftrag" (Standard) ODER fester Techniker. -->
      <fieldset class="bm-fieldset">
        <label class="bm-fieldset-label">Ziel-Techniker</label>
        <div class="flex gap-1 flex-wrap">
          <button type="button" class="bm-btn bm-btn-xs"
                  [class.bm-btn-primary]="targetUserFromOperation()"
                  (click)="toggleTargetUserFromOperation(true)">Vom Auftrag übernehmen</button>
          <button type="button" class="bm-btn bm-btn-xs"
                  [class.bm-btn-primary]="!targetUserFromOperation()"
                  (click)="toggleTargetUserFromOperation(false)">Fester Techniker</button>
        </div>
      </fieldset>

      @if (targetUserFromOperation()) {
        <div class="pl-3 flex flex-col gap-1">
          <div class="bm-alert bm-alert-info bm-alert-soft text-xs">
            <fa-icon [icon]="iconInfo" />
            <span>
              Der Ziel-Techniker wird automatisch vom <strong>Auftragstechniker</strong> übernommen
            </span>
          </div>
          <!-- Aktuelle Auflösung des Auftragstechnikers (Anzeige). Das Ziel-Lager
               folgt im Regel-Modus dem aufgelösten Techniker (LagerApp/ProjectTechnician). -->
          <div class="text-xs px-1">
            <span class="opacity-70">Aktuelle Auswahl: </span>
            <span class="font-semibold">{{ operationTechnicianName || 'kein Techniker — Lagerist wählt beim Versand' }}</span>
          </div>
          @if (operationTechnicianIsPlaceholder) {
            <div class="bm-alert bm-alert-warning bm-alert-soft text-xs">
              <fa-icon [icon]="iconWarn" />
              <span>
                Der Auftragstechniker ist ein <strong>Platzhalter</strong> ({{ operationTechnicianName }}). Der
                Versand kann in der LagerApp erst durchgeführt werden, sobald am Auftrag ein echter Techniker
                gesetzt ist.
              </span>
            </div>
          }
        </div>
      } @else {
        <div class="grid gap-x-2" [class.grid-cols-2]="targetUserId() != null" [class.grid-cols-1]="targetUserId() == null">
          <fieldset class="bm-fieldset">
            <label class="bm-fieldset-label">Fester Ziel-Techniker</label>
            <select class="bm-select w-full" [ngModel]="targetUserId()" (ngModelChange)="onTechnicianChange($event)">
              <option [ngValue]="null">-- Techniker auswählen --</option>
              @for (tech of technicians(); track tech.id) {
                <option [ngValue]="tech.id">{{ tech.name }}</option>
              }
            </select>
          </fieldset>

          @if (targetUserId() != null) {
            <fieldset class="bm-fieldset">
              <label class="bm-fieldset-label">Ziel-Lager des Technikers</label>
              @if (loadingWarehouses()) {
                <div class="text-sm opacity-60 italic min-h-[2.25rem] flex items-center">Lade Lager…</div>
              } @else if (technicianWarehouses().length === 0) {
                <div class="text-sm opacity-60 italic min-h-[2.25rem] flex items-center">Kein Lager verfügbar</div>
              } @else {
                <select class="bm-select w-full" [ngModel]="targetWarehouseId" (ngModelChange)="targetWarehouseId = $event">
                  <option [ngValue]="null">-- Lager auswählen --</option>
                  @for (w of technicianWarehouses(); track w.id) {
                    <option [ngValue]="w.id">{{ w.label }}</option>
                  }
                </select>
              }
            </fieldset>
          }
        </div>
      }
    }

    <!-- Technikerversand-Adresse: Buero legt fest, ob an die Privatadresse oder
         die Lageradresse (Umbuchungslager) verschickt wird. Der Lagerist kann das
         in der LagerApp dann nicht mehr aendern. -->
    @if (selectedType() === 'technician_shipping') {
      <fieldset class="bm-fieldset mt-2">
        <label class="bm-fieldset-label">Versand an</label>
        <select class="bm-select w-full" [ngModel]="technicianShipTarget()"
                (ngModelChange)="technicianShipTarget.set($event)">
          <option value="warehouse">Lageradresse (Umbuchungslager)</option>
          <option value="private">Privatadresse des Technikers</option>
        </select>
        <span class="text-xs opacity-60 mt-1">
          Legt fest, wohin die LagerApp den Technikerversand schickt — der Lagerist kann es dort nicht mehr ändern.
        </span>
      </fieldset>
    }

    <!-- PickPoint-Abholauftrag: eigener Termin (wann der Abholauftrag fuer den
         begleitenden Techniker erzeugt wird). Steht bewusst UEBER dem
         Versandzeitpunkt, da er weder zum normalen Versand- noch zum Staging-
         Datum gehoert. -->
    @if (selectedType() === 'pickpoint') {
      <fieldset class="bm-fieldset mt-3">
        <label class="bm-fieldset-label">Bei Versand: Abholauftrag generieren
          @if (pickupOpeningHint(); as hint) {
            <span class="opacity-60">({{ hint }})</span>
          }
        </label>
        <input class="bm-input w-full" type="datetime-local"
          [ngModel]="pickupDate()"
          (ngModelChange)="pickupDate.set($event || '')" />
        @if (pickupValidityError(); as err) {
          <div class="bm-alert bm-alert-warning bm-alert-soft text-xs mt-1">{{ err }}</div>
        } @else {
          <span class="text-xs opacity-60 mt-1">Standard: 1 h vor Einsatzbeginn.</span>
        }
        <!-- Bereits generierter Abholauftrag: verlinken + auf den Sync hinweisen
             (Abholdatum-Änderung verschiebt Abholauftrag + Geschwister-Configs). -->
        @if (initialConfig?.pickup_operation_id && initialConfig?.pickup_ticket_id) {
          <div class="text-xs mt-1 flex flex-col gap-0.5">
            <a [routerLink]="['/ticket', initialConfig?.pickup_ticket_id]" target="_blank"
               class="text-primary hover:underline w-fit">
              Abholauftrag öffnen (Ticket #{{ initialConfig?.pickup_ticket_id }}) ↗
            </a>
            <span class="opacity-60">
              Änderungen am Abholdatum verschieben auch den Abholauftrag und alle mit ihm
              verlinkten Versandconfigs (inkl. deren Offset-Terminen).
            </span>
          </div>
        }
      </fieldset>
    }

    <!-- Versandzeitpunkt: buendelt die Termin-Felder (Versanddatum, Staging-
         Versand) in einem eigenen Bereich. Macht explizit, dass normaler Versand
         und Staging-Versand zu UNTERSCHIEDLICHEN Zeitpunkten rausgehen —
         Mitarbeiter nahmen bisher faelschlich an, das Versanddatum gelte auch
         fuer den Staging-Versand. -->
    <div class="mt-3 border border-base-300 rounded-lg p-3 flex flex-col gap-2">
      <div class="text-sm font-semibold flex items-center gap-1">
        <fa-icon [icon]="iconClock" />Versandzeitpunkt
      </div>

      <div class="bm-alert bm-alert-info bm-alert-soft text-xs">
        <fa-icon [icon]="iconInfo" />
        <span>
          Normaler Versand und Staging-Versand gehen zu <strong>getrennten Zeitpunkten</strong> raus.
          Das <strong>Versanddatum</strong> gilt nur für den normalen Versand (Artikelbedarf-Versandartikel)@if (showStagingDelay()) {; der Staging-Versand richtet sich nach dem Feld „Staging-Versand"}.
        </span>
      </div>

      <fieldset class="bm-fieldset">
        <label class="bm-fieldset-label">Versanddatum</label>
        <div class="flex gap-1 flex-wrap mb-1">
          <button type="button" class="bm-btn bm-btn-xs"
                  [class.bm-btn-primary]="shippingDateMode() === 'offset'"
                  (click)="shippingDateMode.set('offset')">{{ offsetWording().mode }}</button>
          <!-- Versandfenster „Zeitraum vor Auftrag" — für PickPoint nicht wählbar
               (der Abholtermin taktet dort den Versand). selectWindowMode()
               sorgt für eine konsistente Vorbelegung (kein invalides Fenster
               beim Umschalten aus dem Offset-Modus). -->
          @if (selectedType() !== 'pickpoint') {
            <button type="button" class="bm-btn bm-btn-xs"
                    [class.bm-btn-primary]="shippingDateMode() === 'window'"
                    (click)="selectWindowMode()">Zeitraum vor Auftrag</button>
          }
          <button type="button" class="bm-btn bm-btn-xs"
                  [class.bm-btn-primary]="shippingDateMode() === 'fixed'"
                  (click)="shippingDateMode.set('fixed')">Datum</button>
        </div>
        @if (shippingDateMode() === 'offset') {
          <label class="bm-input">
            <input type="number" min="0" [ngModel]="shippingOffsetDays()"
                   (ngModelChange)="shippingOffsetDays.set($event)" />
            <span class="bm-label">{{ offsetWording().unit }}</span>
          </label>
          <span class="text-xs opacity-60 mt-1">Versand automatisch N Werktage vor dem {{ offsetWording().noun }} (0 = am {{ offsetWording().day }}).</span>
        } @else if (shippingDateMode() === 'window' && selectedType() !== 'pickpoint') {
          <!-- Chronologische Reihenfolge wie in der LagerApp („früh – spät"):
               links „von" = frühester Versandtag (MEHR Werktage vor Auftrag),
               rechts „bis" = spätester Versandtag. -->
          <div class="flex gap-2">
            <label class="bm-input flex-1">
              <span class="bm-label">von</span>
              <input type="number" min="0" [ngModel]="earliestOffsetDays()"
                     (ngModelChange)="earliestOffsetDays.set($event)" />
              <span class="bm-label">Werktage (frühestens)</span>
            </label>
            <label class="bm-input flex-1">
              <span class="bm-label">bis</span>
              <input type="number" min="0" [ngModel]="shippingOffsetDays()"
                     (ngModelChange)="shippingOffsetDays.set($event)" />
              <span class="bm-label">Werktage (spätestens)</span>
            </label>
          </div>
          @if (windowRangeInvalid()) {
            <span class="text-xs text-error mt-1">
              „von (frühestens)" muss ≥ „bis (spätestens)" sein — mehr Werktage vor dem Auftrag = früherer Tag.
            </span>
          } @else {
            <span class="text-xs opacity-60 mt-1">
              Versandfenster: frühestens {{ earliestOffsetDays() }}, spätestens {{ shippingOffsetDays() }} Werktage vor dem Auftragsdatum —
              das Lager darf an jedem Tag im Zeitraum versenden (z.&nbsp;B. gebündelt im Sammelversand).
            </span>
          }
        } @else {
          <input class="bm-input w-full" type="date"
            [ngModel]="shippingDate()"
            (ngModelChange)="shippingDate.set($event || '')" />
          <span class="text-xs opacity-60 mt-1">{{ shippingDateHint }}</span>
        }
      </fieldset>

      <!-- Verzoegerter Staging-Versand: optionaler frueheste-Versand-Zeitpunkt.
           Gesetzt = Staging-Pakete werden in der LagerApp vorbereitet, aber erst
           ab diesem Zeitpunkt als versandt markierbar. -->
      @if (showStagingDelay()) {
        <fieldset class="bm-fieldset">
          <label class="bm-fieldset-label">Staging-Versand (optional)</label>
          <div class="flex gap-1 flex-wrap mb-1">
            <button type="button" class="bm-btn bm-btn-xs"
                    [class.bm-btn-primary]="stagingShipMode() === 'offset'"
                    (click)="stagingShipMode.set('offset')">{{ offsetWording().mode }}</button>
            <button type="button" class="bm-btn bm-btn-xs"
                    [class.bm-btn-primary]="stagingShipMode() === 'fixed'"
                    (click)="stagingShipMode.set('fixed')">Datum</button>
            <button type="button" class="bm-btn bm-btn-xs"
                    [class.bm-btn-primary]="stagingShipMode() === 'standard'"
                    (click)="stagingShipMode.set('standard')">KW-Zuordnung (Standard)</button>
          </div>
          @if (stagingShipMode() === 'offset') {
            <label class="bm-input">
              <input type="number" min="0" [ngModel]="stagingOffsetDays()"
                     (ngModelChange)="stagingOffsetDays.set($event)" />
              <span class="bm-label">{{ offsetWording().unit }}</span>
            </label>
            <span class="text-xs opacity-60 mt-1">Staging-Versand automatisch N Werktage vor dem {{ offsetWording().noun }} (09:00 Uhr). Pakete dürfen erst ab diesem Termin physisch losgeschickt werden.</span>
          } @else if (stagingShipMode() === 'fixed') {
            <input class="bm-input w-full" type="datetime-local"
              [ngModel]="stagingShipReadyAt()"
              (ngModelChange)="stagingShipReadyAt.set($event || '')" />
            <span class="text-xs opacity-60 mt-1">
              Pakete dürfen erst ab diesem Termin physisch losgeschickt werden.
            </span>
          } @else {
            <span class="text-xs opacity-60 mt-1">
              Versand nach KW-Zuordnung durch die Staging-Config — keine Verzögerung.
            </span>
          }
        </fieldset>
      }
    </div>

    <!-- Erweiterte Einstellungen (collapsible): aktuell nur PM-Code (PickPoint).
         Die Lageristen-Notiz (notes) wird nicht mehr hier gesetzt, sondern in der
         Versand-Matrix pro Config. Bei anderen Versandtypen entfällt der Bereich. -->
    @if (selectedType() === 'pickpoint') {
      <div class="mt-2 border-t border-base-200 pt-2">
        <button type="button"
                class="bm-btn bm-btn-ghost bm-btn-sm"
                (click)="showAdvancedSection.set(!showAdvancedSection())">
          {{ showAdvancedSection() ? '▾' : '▸' }} Erweiterte Einstellungen
        </button>

        @if (showAdvancedSection()) {
          <div class="mt-2 flex flex-col gap-2">
            <!-- PM-Code: bei PickPoint immer hier, mit Hilfetext je nachdem
                 ob er vom System vorbelegt wurde oder nicht. -->
            <fieldset class="bm-fieldset">
              <label class="bm-fieldset-label">PM-Code <span class="text-error">*</span></label>
              <input class="bm-input w-full" type="text" placeholder="z.B. PM-692636"
                     [ngModel]="pmCode()" (ngModelChange)="pmCode.set($event)" />
              <span class="text-xs opacity-60 mt-1">
                @if (pmCodeAutoLoaded()) {
                  Aus dem System-User vorbelegt — nur ändern, wenn der Kunde einen abweichenden Code vorgibt.
                } @else {
                  Vom Kunden vorgegebener Code, identifiziert den Abholberechtigten an der Station.
                }
              </span>
            </fieldset>
          </div>
        }
      </div>
    }

    <!-- Aktionen -->
    <div class="flex gap-2 mt-3 justify-end">
      <button class="bm-btn bm-btn-ghost bm-btn-sm" type="button" (click)="cancel.emit()">
        Abbrechen
      </button>
      <button class="bm-btn bm-btn-primary bm-btn-sm" type="button"
              (click)="emitSave()" [disabled]="!canSave()">
        {{ saveLabel }}
      </button>
    </div>
  </div>
</div>

<!-- PickPoint-Karten-Popup -->
@if (showMapPicker() && canOpenMap()) {
  <hawk-pickpoint-map-picker
    [centerLat]="ticketLat!"
    [centerLng]="ticketLng!"
    [referenceDate]="referenceDate"
    [initialStationId]="selectedStation()?.id"
    (stationSelected)="onMapStationPicked($event)"
    (closed)="showMapPicker.set(false)"
  />
}
